import type { InviteByEmailData, ShareAuthCheckData, ShareLinkResponse, ExecuteShareTaskResponse, ShareOwnerResponse, ShareTrackData } from '../types';

export const ShareIdRepository = Symbol('ShareIdRepository');

export const EmailInviteRepository = Symbol('EmailInviteRepository');

export const DuplicateCreateRepository = Symbol('DuplicateCreateRepository');

export const DuplicateExecuteRepository = Symbol('DuplicateExecuteRepository');

export const ShareAccessCheckRepository = Symbol('ShareAccessCheckRepository');

export const ShareOwnerInfoRepository = Symbol('ShareOwnerInfoRepository');

export const ShareTrackRepository = Symbol('ShareTrackRepository');

export interface ShareIdRepository {
    getShareId(data: ShareAuthCheckData): Promise<ShareLinkResponse>
}

export interface EmailInviteRepository {
    inviteByEmail(data: InviteByEmailData): Promise<boolean>
}

export interface DuplicateCreateRepository {
    createShareTask(data: ShareAuthCheckData): Promise<string>
}

export interface DuplicateExecuteRepository {
    executeShareTask(data: string): Promise<ExecuteShareTaskResponse>
}

export interface ShareAccessCheckRepository {
    shareAccessCheck(data: ShareAuthCheckData): Promise<boolean>
}

export interface ShareOwnerInfoRepository {
    getShareOwnerInfo(data: ShareAuthCheckData): Promise<ShareOwnerResponse>
}

export interface ShareTrackRepository {
    trackShare(data: ShareTrackData): Promise<boolean>
}
